module.exports = __webpack_public_path__ + "media/images/div_lens/traditional-img-4eb491b2925c01f4fcfb55cbc3cf6934.jpg";